import {
  apiClient,
} from "./apiClient";

import type {
  DashboardProfileData,
  DashboardProfilePasswordResetLinkData,
  DashboardProfilePasswordUpdatedData,
  DashboardProfileSessionsRevokedData,
  UpdateDashboardProfileInput,
  UpdateDashboardProfilePhotoInput,
} from "../types/dashboard-profile.types";

export const dashboardProfileApi = {
  /**
   * =========================================================
   * GET /dashboard-profile/me
   * =========================================================
   */

  getMe() {
    return apiClient.get<
      DashboardProfileData
    >(
      "/dashboard-profile/me",
    );
  },

  /**
   * =========================================================
   * PATCH /dashboard-profile/me
   * =========================================================
   */

  update(
    input:
      UpdateDashboardProfileInput,
  ) {
    return apiClient.patch<
      DashboardProfileData
    >(
      "/dashboard-profile/me",
      input,
    );
  },

  /**
   * =========================================================
   * PATCH /dashboard-profile/me/password
   * =========================================================
   */

  updatePassword(
    password: string,
  ) {
    return apiClient.patch<
      DashboardProfilePasswordUpdatedData
    >(
      "/dashboard-profile/me/password",
      {
        password,
      },
    );
  },

  /**
   * =========================================================
   * POST /dashboard-profile/me/password-reset-link
   * =========================================================
   */

  createPasswordResetLink() {
    return apiClient.post<
      DashboardProfilePasswordResetLinkData
    >(
      "/dashboard-profile/me/password-reset-link",
      {},
    );
  },

  /**
   * =========================================================
   * POST /dashboard-profile/me/revoke-sessions
   * =========================================================
   */

  revokeSessions() {
    return apiClient.post<
      DashboardProfileSessionsRevokedData
    >(
      "/dashboard-profile/me/revoke-sessions",
      {},
    );
  },

  /**
   * =========================================================
   * PATCH /dashboard-profile/me/photo
   * =========================================================
   */

  updatePhoto(
    input:
      UpdateDashboardProfilePhotoInput,
  ) {
    return apiClient.patch<
      DashboardProfileData
    >(
      "/dashboard-profile/me/photo",
      input,
    );
  },

  /**
   * =========================================================
   * DELETE /dashboard-profile/me/photo
   * =========================================================
   */

  deletePhoto() {
    return apiClient.delete<
      DashboardProfileData
    >(
      "/dashboard-profile/me/photo",
    );
  },
};